module.exports = __webpack_public_path__ + "img/homework.382743bd.svg";